/* eslint-disable camelcase */
import React from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { IOption } from '../../types/customizer';
import If from '../../../../components/Shared/If';
import './index.scss';
import URLs from '../../../../utils/url';

interface ISwatchOption extends IOption {
  hasSwatch: boolean;
  displayShowMoreOption: boolean;
  fieldType: string;
  onChange: (updated: any) => void;
  selectedOption: IOption;
  isChanging: string;
}

const SwatchOption = ({ type, name, short_name, swatch_url, selected, sku, additionalClassName, hasSwatch, displayShowMoreOption, fieldType, onChange,
    selectedOption, isChanging }: ISwatchOption) => {
    const handleClick = () => {
        if (!selected) {
            onChange({ [fieldType]: sku });
        }
    };

    if (hasSwatch) {
        return (
            <div className={clsx({ 'sm:tw-w-28 tw-text-center sm:tw-mr-5 tw-my-2 tw-relative': true, 'selected-border': isChanging === sku })}>
                <div className="xs:tw-px-1.5 sm:tw-px-2">
                    <div
                        className={clsx('tw-inline-block', { 'tw-border tw-border-dashed tw-border-black tw-rounded-full': selected && !isChanging })}
                        role="presentation"
                        onClick={handleClick}
                    >
                        <div
                            className="xs:tw-w-16 xs:tw-h-16 sm:tw-w-22.5 sm:tw-h-22.5 tw-rounded-full tw-cursor-pointer tw-bg-no-repeat tw-bg-center tw-bg-contain tw-m-1"
                            style={{ backgroundImage: `url(${URLs.assetsBaseUrl}${swatch_url})` }}
                        />
                    </div>
                    {/* Show only for md devices (768px) */}
                    <div className="tw-text-sm tw-text-blue-900 tw-font-normal tw-mt-1 tw-pl-1 md:tw-block tw-hidden">{name}</div>
                    {/* Show only for less than md devices (768px) */}
                    <div className="tw-text-sm tw-text-blue-900 tw-font-normal tw-mt-1 tw-pl-1 md:tw-hidden tw-block">{short_name || name}</div>
                </div>
            </div>);
    }
    return (
        <div className={clsx({ 'tw-p-1.5 sm:tw-p-2 tw-cursor-pointer tw-relative': true, 'selected-border-square ': isChanging === sku })}>
            <If condition={name || sku}>
                <div
                    className={twMerge(clsx({
                        'tw-p-1.5  sm:tw-p-2 tw-border tw-border-solid tw-rounded tw-text-center min-w-18 tw-text-sm tw-text-blue-900 tw-font-medium': true,
                        'tw-border-gray-400': !selected || isChanging,
                        'tw-border-dashed tw-border-black': selected && !isChanging,
                    }), `${additionalClassName}`)}
                    role="presentation"
                    onClick={handleClick}
                >
                    {sku === 'CUSTOM' ? sku : name.replace(/(\d+)mm/g, '$1 mm')}
                </div>
            </If>
        </div>
    );
};

export default SwatchOption;
